import React, { useState } from 'react'
import BannerThree from './bannerThree'
import BlogThree from './blogThree'
import HowItWorksThree from './howItWorksThree'
import PopularCar from './popularCar'
import TestimonialThree from './testimonialThree'
import TrendingThree from './trendingThree'
import FooterThree from './footerThree'

const HomeThree = () => {


  
    
  return (
    <>
    <BannerThree/>
     <TrendingThree/>
    <PopularCar/>
    <HowItWorksThree/>
    <TestimonialThree/>
    <BlogThree/>
    <FooterThree/>
    </>
  )
}

export default HomeThree